export class OptionsStore {
    constructor() {
        this.options = {};
    }
}
//# sourceMappingURL=options-store.js.map